var _rect, _path, _path2, _circle, _rect2, _rect3, _rect4, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMarbleThumbnail = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 102,
    viewBox: "0 0 103 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-background",
    x: 1.22559,
    y: 0.5,
    width: 101,
    height: 101,
    rx: 10.5,
    fill: "#D1ECE4",
    stroke: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.72559 11V17H48.2256C49.3302 17 50.2256 16.1046 50.2256 15V1H11.7256C6.20274 1 1.72559 5.47715 1.72559 11Z",
    fill: "#F1AE5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.726 91L101.726 85L44.7256 85C43.621 85 42.7256 85.8954 42.7256 87L42.7256 101L91.7256 101C97.2484 101 101.726 96.5228 101.726 91Z",
    fill: "#52BDA4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-ball",
    cx: 58.7119,
    cy: 51,
    r: 25.8607,
    fill: "#2CAECB",
    stroke: "#3F5574",
    strokeWidth: 1.72149
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-ball",
    x: 20.7046,
    y: 56.3803,
    width: 10.3728,
    height: 4.44547,
    rx: 2.22273,
    fill: "#2CAECB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-ball",
    x: 20.7046,
    y: 41.5591,
    width: 10.3728,
    height: 4.44547,
    rx: 2.22273,
    fill: "#2CAECB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-ball",
    x: 17,
    y: 48.9712,
    width: 11.8546,
    height: 4.44547,
    rx: 2.22273,
    fill: "#2CAECB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1193 49.8066C82.5513 50.2078 82.5442 50.8936 82.1042 51.2858L67.2853 64.4937C66.4914 65.2013 65.2881 64.3448 65.6967 63.3629L70.3208 52.2524C70.8192 51.0549 70.8327 49.7107 70.3586 48.5034L66.0155 37.4445C65.6267 36.4545 66.8474 35.6224 67.6268 36.3463L82.1193 49.8066Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMarbleThumbnail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/MarbleThumbnail.dda6afdd3b1419484c841671e7ee01d2.svg";